import './loader.css';
import React from 'react';
var Loader = function Loader(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(className)
  });
};
export default Loader;
var commonStyles = "c1qd8izy";